/**
 * External dependencies
 */
import type { ReusableGoal, ReusableSegment } from '@nab/types';

/**
 * Internal dependencies
 */
import type { State } from '../types';

export function getReusableGoals(
	state: State
): ReadonlyArray< ReusableGoal > {
	return state.reusableEntities.goals;
}

export function getReusableSegments(
	state: State
): ReadonlyArray< ReusableSegment > {
	return state.reusableEntities.segments;
}

export function isSavingReusableEntities( state: State ): boolean {
	return state.reusableEntities.isSavingEntities;
}
